module.exports = __webpack_public_path__ + "static/img/02_01_gate.f7462c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/02_01_gate.png
// module id = +oea
// module chunks = 12